import React, { useState, useEffect, useRef } from "react";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";

export default function CustomSelect({ value, options, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(null);
    const dropdownRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const containerStyle = {
        position: 'relative',
        width: '100%',
        outline: 'none'
    };

const triggerStyle = {
  padding: '0.3rem 0.7rem',
  fontSize: '0.875rem',
  border: `0.5px solid ${isOpen ? "#80bdff" : "#ced4da"}`, 
  borderRadius: '0.25rem',
  backgroundColor: 'transparent',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer'
};

    const arrowStyle = {
        fontSize: '1em',
        color: '#495057'
    };

    const optionsContainerStyle = {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: 'white',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #ced4da',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        boxSizing: 'border-box',
        borderRadius: '4px'
    };

    const optionStyle = {
        padding: '0.5rem 0.75rem',
        cursor: 'pointer'
    };

    const optionHoverStyle = {
        ...optionStyle,
        backgroundColor: '#f1f1f1'
    };

    const selectedOptionStyle = {
        ...optionStyle,
        backgroundColor: '#eff4fb'
    };

    return (
        <div style={containerStyle} ref={dropdownRef}>
            <div 
                style={triggerStyle} 
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{selectedOption ? selectedOption.label : 'Select...'}</span>
                <div style={arrowStyle}>
                    {isOpen ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
                </div>
            </div>

            {isOpen && (
                <div style={optionsContainerStyle}>
                    {options.map((option, index) => {
                        const isSelected = option.value === value;
                        return (
                            <div
                                key={option.value}
                                style={
                                    isSelected
                                        ? selectedOptionStyle
                                        : hoverIndex === index
                                            ? optionHoverStyle
                                            : optionStyle
                                }
                                onClick={() => {
                                    onChange(option.value);
                                    setIsOpen(false); 
                                }}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                            >
                                {option.label}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}